module.exports = __webpack_public_path__ + "static/media/screenshot(27).51b18526.jpg";